/**
 * 읽는 데 걸리는 시간(분).
 * @description 데스크톱 시안의 카드·상세가 "4 min" 을 보여준다. 서버가 주지 않으므로 본문에서
 *   센다 — 영문은 낱말 수, 한글·한자·가나는 글자 수로. 두 셈법의 분당 속도가 다르다.
 * @example readingMinutes("# 제목\\n\\n본문 …") // 1
 */
const WORDS_PER_MINUTE = 220;
/** 한글은 낱말 경계가 흐려 글자로 센다 — 분당 약 500자 */
const CJK_CHARS_PER_MINUTE = 500;
const CJK = /[ᄀ-ᇿ぀-ヿ㐀-鿿가-힯]/g;

export function readingMinutes(markdown: string): number {
  const cjkChars = markdown.match(CJK)?.length ?? 0;
  const words = markdown
    .replace(CJK, " ")
    .replace(/[#>*_`\-\[\]()!]/g, " ")
    .split(/\s+/)
    .filter(Boolean).length;
  const minutes = words / WORDS_PER_MINUTE + cjkChars / CJK_CHARS_PER_MINUTE;
  return Math.max(1, Math.round(minutes));
}
